import { 
     CREATEREFERRALCATEGORY,
     CREATEREFERRALCOMMITION,
     CREATEREFERRALMODULECOMMITION,
     DELETEREFERRALCATEGORY, 
     DELETEREFERRALCOMMITION, 
     DELETEREFERRALMODULECOMMITION, 
     GETREFERRALCATEGORY,
     GETREFERRALCOMMITION,
     GETREFERRALMODULECOMMITION,
     UPDATEREFERRALCATEGORY,
     UPDATEREFERRALCOMMITION,
     UPDATEREFERRALMODULECOMMITION,

     CREATEREFERRALTYPE,      // NEW
     GETREFERRALTYPE,         // NEW
     UPDATEREFERRALTYPE,      // NEW
     DELETEREFERRALTYPE,      // NEW
    
    } from '../actions/types';

const initialState = {
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {

    switch (action.type) {
        case CREATEREFERRALCATEGORY:
            return {
                ...state,
                referralcategorySaveStatus: action.payload.success,
            }
        case GETREFERRALCATEGORY:
                return {
                        ...state,
                        referralcategoryList: action.payload.data,
                        }
        case UPDATEREFERRALCATEGORY:
                return {
                        ...state,
                        referralcategoryUpdateStatus: action.payload.success,
                        }   

        case DELETEREFERRALCATEGORY:
                return {
                     ...state,
                     referralcategoryDeleteStatus: action.payload.success,
                        } 
        case CREATEREFERRALCOMMITION:
            return {
                ...state,
                referralcommissionSaveStatus: action.payload.success,
            }
        case GETREFERRALCOMMITION:
                return {
                        ...state,
                        referralcommissionList: action.payload.data,
                        }
        case UPDATEREFERRALCOMMITION:
                return {
                        ...state,
                        referralcommissionUpdateStatus: action.payload.success,
                        }   

        case DELETEREFERRALCOMMITION:
                return {
                     ...state,
                     referralcommissionDeleteStatus: action.payload.success,
                        } 
        case CREATEREFERRALMODULECOMMITION:
            return {
                ...state,
                referralmodulecommissionSaveStatus: action.payload.success,
            }
        case GETREFERRALMODULECOMMITION:
                return {
                        ...state,
                        referralmodulecommissionList: action.payload.data,
                        }
        case UPDATEREFERRALMODULECOMMITION:
                return {
                        ...state,
                        referralmodulecommissionUpdateStatus: action.payload.success,
                        }   

        case DELETEREFERRALMODULECOMMITION:
                return {
                     ...state,
                     referralmodulecommissionDeleteStatus: action.payload.success,
                        }
                        
        case CREATEREFERRALTYPE:
                return {
                    ...state,
                    referraltypeSaveStatus: action.payload.success,
                }
        case GETREFERRALTYPE:
                return {
                            ...state,
                            referraltypeList: action.payload.data,
                            }
        case UPDATEREFERRALTYPE:
                return {
                            ...state,
                            referraltypeUpdateStatus: action.payload.success,
                            }   

        case DELETEREFERRALTYPE:
                return {
                        ...state,
                        referraltypeDeleteStatus: action.payload.success,
                            }
                                    default:
                                        return state
                                            }
                                        }